"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(cookie) {
  var cookieData = {};
  (cookie || '').split('&').forEach(function (seg) {
    var parts = seg.split('=');

    if (parts.length === 2) {
      var name = decodeURIComponent(parts[0]);
      var value = decodeURIComponent(parts[1]);
      cookieData[name] = value;
    }
  });
  return cookieData;
};

exports["default"] = _default;